import React from 'react';
import { Menu, MenuButton, MenuList, MenuItem, IconButton, Icon } from '@chakra-ui/react';
import { MenuPortal, useInDrawer } from './portalTarget';
import { FiPaperclip, FiImage, FiFileText } from 'react-icons/fi';

/**
 * The paperclip: Photos & videos, or Document — the two pickers WhatsApp
 * offers on the web. Hidden file inputs do the picking so the menu stays a
 * menu.
 */
export default function AttachMenu({ onFiles, isDisabled }) {
	const inDrawer = useInDrawer();
	// This short menu fits above the composer inside the drawer. Keep it next
	// to its trigger so it shares the composer's positioning and focus boundary,
	// instead of positioning through the drawer's separate portal anchor.
	const MenuContainer = inDrawer ? React.Fragment : MenuPortal;
	const mediaInput = React.useRef(null);
	const docInput = React.useRef(null);

	const pick = (e) => {
		const files = Array.from(e.target.files ?? []);
		// Reset so choosing the same file twice in a row fires again.
		e.target.value = '';
		if (files.length) onFiles(files);
	};

	return (
		<>
			<Menu placement="top-start" strategy={inDrawer ? 'absolute' : 'fixed'} isLazy>
				<MenuButton
					as={IconButton}
					aria-label="Attach"
					icon={<Icon as={FiPaperclip} boxSize="26px" />}
					variant="ghost"
					size="md"
					borderRadius="full"
					color="wa.inkMuted"
					_hover={{ color: 'wa.ink', bg: 'wa.hover' }}
					isDisabled={isDisabled}
				/>
				<MenuContainer>
					<MenuList zIndex="popover" bg="wa.menu" borderColor="wa.divider" color="wa.ink" minW="200px" boxShadow="lg" fontSize="sm">
						<MenuItem icon={<Icon as={FiImage} color="wa.accent" />} onClick={() => mediaInput.current?.click()} _hover={{ bg: 'wa.hover' }} _focus={{ bg: 'wa.hover' }}>
							Photos &amp; videos
						</MenuItem>
						<MenuItem icon={<Icon as={FiFileText} color="info" />} onClick={() => docInput.current?.click()} _hover={{ bg: 'wa.hover' }} _focus={{ bg: 'wa.hover' }}>
							Document
						</MenuItem>
					</MenuList>
				</MenuContainer>
			</Menu>
			{/* ★ WIDE ON PURPOSE, AND NARROWED LATER BY NAME.
			    A strict `accept` greys out the user's own photos in the picker with
			    no explanation — on an iPhone that is every photo, because they are
			    HEIC. The picker now offers anything the camera roll holds and
			    `useAttachment.describeUnsupported` refuses the handful Meta cannot
			    take, naming the format and what to do instead. Drag-and-drop always
			    ignored `accept` anyway, so this also makes the two paths agree. */}
			<input ref={mediaInput} type="file" accept="image/*,video/*" hidden onChange={pick} />
			<input ref={docInput} type="file" hidden onChange={pick} />
		</>
	);
}
